// NPN Dash — Landing page JS
document.addEventListener('DOMContentLoaded', function () {

  // Smooth scroll for all #anchor links inside .npn sections
  document.querySelectorAll('.npn a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Fade-in on scroll
  var items = document.querySelectorAll(
    '.npn .npn-feat-card, .npn .npn-priv-card, .npn .npn-ss-wrap, .npn .npn-ble-pt, .npn .npn-show-item'
  );
  items.forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(18px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
  });

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        setTimeout(function () {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'none';
        }, i * 70);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  items.forEach(function (el) { obs.observe(el); });
});
